// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.nav {
  display: flex;
  justify-content: space-between;
  padding: 11px 30px 11px 0;
  align-items: center;
  background: transparent;
  position: fixed;
  top: 0;
  z-index: 999;
  transition: all 0.25s ease-in-out;
  width: 100%;
}
.nav a {
  color: #EDEDED;
  order: 3;
}
.nav .logo_nav img {
  vertical-align: middle;
  width: 100%;
}
@media (max-width: 320px) {
  .nav .logo_nav {
    width: 180px;
  }
}
@media (max-width: 1200px) {
  .nav .logo_nav {
    order: 1;
  }
}
.nav .nav_link {
  display: flex;
}
@media (max-width: 1200px) {
  .nav .nav_link {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    position: fixed;
    top: 70px;
    height: auto;
    bottom: 0;
    left: -100%;
    opacity: 1;
    transition: all 0.5s ease;
  }
}
@media (max-width: 1200px) {
  .nav .active1 {
    background: #0A0A0A;
    left: 0;
    opacity: 1;
    transition: all 0.5s ease;
    z-index: 1;
  }
}
.nav .link {
  font-family: "hemi_head";
  padding: 12px 26px;
  position: relative;
  font-size: 16px;
  transition: 0.5s all;
  color: #EDEDED;
}
.nav .link.active {
  color: #ED1C24;
}
.nav .link:hover {
  color: #ED1C24;
}
@media (max-width: 1280px) {
  .nav .link {
    padding: 12px 20px;
  }
}
.nav .menu_icon {
  display: none;
}
.nav .menu_icon img {
  width: 25px;
}
@media (max-width: 1200px) {
  .nav .menu_icon {
    display: block;
    order: 0;
  }
}
.nav #nav-icon1 {
  display: none;
  width: 35px;
  height: 25px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;
}
@media (max-width: 1200px) {
  .nav #nav-icon1 {
    display: block;
  }
}
.nav #nav-icon1 span, .nav #nav-icon3 span, .nav #nav-icon4 span {
  display: block;
  position: absolute;
  height: 3px;
  width: 100%;
  background: #FFFFFF;
  border-radius: 9px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
}
.nav #nav-icon1 span:nth-child(1) {
  top: 0px;
}
.nav #nav-icon1 span:nth-child(2) {
  top: 10px;
}
.nav #nav-icon1 span:nth-child(3) {
  top: 20px;
}
.nav #nav-icon1.open span:nth-child(1) {
  top: 18px;
  transform: rotate(135deg);
}
.nav #nav-icon1.open span:nth-child(2) {
  opacity: 0;
  left: -60px;
}
.nav #nav-icon1.open span:nth-child(3) {
  top: 18px;
  transform: rotate(-135deg);
}
@media (max-width: 1200px) {
  .nav {
    padding: 11px 25px;
  }
}
@media (max-width: 500px) {
  .nav {
    padding: 15px;
  }
}
@media (max-width: 1200px) {
  .nav .mob_links {
    display: flex;
    flex-direction: column;
  }
}
.nav .media {
  display: none;
}
@media (max-width: 1200px) {
  .nav .media {
    display: flex;
    list-style: none;
    margin: 10px 0;
    justify-content: center;
    padding: 0;
  }
  .nav .media li {
    padding: 0 7px;
  }
  .nav .media img {
    width: 25px;
  }
}
.nav .content {
  display: none;
}
@media (max-width: 1200px) {
  .nav .content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-left: 12px;
    flex-wrap: wrap;
    margin-bottom: 25px;
  }
}
@media (max-width: 1200px) and (max-width: 1386px) {
  .nav .content {
    width: 95%;
  }
}
@media (max-width: 1200px) and (max-width: 790px) {
  .nav .content div {
    width: 100%;
    text-align: center;
  }
}
@media (max-width: 1200px) {
  .nav .content .links {
    display: flex;
  }
  .nav .content .links ul {
    display: flex;
    flex-direction: column;
    margin-left: 30px;
  }
  .nav .content ul {
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .nav .content ul li {
    padding: 4px;
    display: flex;
  }
  .nav .content ul li svg {
    margin-right: 10px;
    width: 23px;
  }
  .nav .content ul a {
    color: rgba(255, 255, 255, 0.63);
    font-size: 18px;
  }
}
@media (max-width: 1200px) and (max-width: 640px) {
  .nav .content ul a {
    font-size: 15px;
  }
}
@media (max-width: 1200px) {
  .nav {
    background: #0A0A0A;
    position: sticky;
  }
}
.nav li.dropdown {
  display: inline-block;
}
.nav .dropdown-content {
  display: none;
  position: absolute;
  top: 30px;
  left: 0;
  background-color: #0A0A0A;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.nav .dropdown-content a {
  color: #FFFFFF;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
  text-align: left;
}
.nav .dropdown-content a:hover {
  background-color: #0A1315;
}
.nav .dropdown:hover .dropdown-content {
  display: block;
}
.nav .dropbtn::after {
  content: "▼";
  transition: 0.2s;
  position: absolute;
}
.nav .dropbtn::after:hover {
  transform: rotate(-180deg);
}
.nav .dropdown:hover .dropbtn::after {
  transform: rotate(-180deg);
}

.colorChange {
  background: #0A0A0A;
}`, "",{"version":3,"sources":["webpack://./src/Components/Navbar/Navbar.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,aAAA;EACA,8BAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,MAAA;EACA,YAAA;EACA,iCAAA;EACA,WAAA;AAEF;AAAE;EACE,cAAA;EACA,QAAA;AAEJ;AAGM;EACE,sBAAA;EACA,WAAA;AADR;AAKI;EARF;IASI,YAAA;EAFJ;AACF;AAGI;EAXF;IAYG,QAAA;EAAH;AACF;AAGE;EACE,aAAA;AADJ;AAEI;EAFF;IAGI,aAAA;IACA,sBAAA;IACA,8BAAA;IACA,WAAA;IACA,eAAA;IACA,SAAA;IACA,YAAA;IACA,SAAA;IACA,WAAA;IACA,UAAA;IACA,yBAAA;EACJ;AACF;AAEI;EADF;IAEI,mBAAA;IACA,OAAA;IACA,UAAA;IACA,yBAAA;IACA,UAAA;EACJ;AACF;AAGE;EACE,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAAA;AADJ;AAGI;EACE,cAAA;AADN;AAGI;EACE,cAAA;AADN;AAII;EAfF;IAgBI,kBAAA;EADJ;AACF;AAIE;EACE,aAAA;AAFJ;AAII;EACE,WAAA;AAFN;AAKI;EAPF;IAQI,cAAA;IACA,QAAA;EAFJ;AACF;AAIE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EAIA,uBAAA;EAIA,4BAAA;EACA,eAAA;AAFJ;AAGI;EAdF;IAeI,cAAA;EAAJ;AACF;AAGE;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,OAAA;EAIA,uBAAA;EAIA,6BAAA;AADJ;AAIE;EACE,QAAA;AAFJ;AAKE;EACE,SAAA;AAHJ;AAME;EACE,SAAA;AAJJ;AAOE;EACE,SAAA;EAIA,yBAAA;AALJ;AAQE;EACE,UAAA;EACA,WAAA;AANJ;AASE;EACE,SAAA;EAIA,0BAAA;AAPJ;AASE;EAlKF;IAmKI,kBAAA;EANF;AACF;AAOE;EArKF;IAsKI,aAAA;EAJF;AACF;AAMI;EADF;IAEI,aAAA;IACA,sBAAA;EAHJ;AACF;AAKE;EACE,aAAA;AAHJ;AAII;EAFF;IAGI,aAAA;IACA,gBAAA;IACA,cAAA;IACA,uBAAA;IACA,UAAA;EADJ;EAEI;IACE,cAAA;EAAN;EAGI;IACE,WAAA;EADN;AACF;AAIE;EACE,aAAA;AAFJ;AAGI;EAFF;IAGI,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,WAAA;IACA,iBAAA;IACA,eAAA;IACA,mBAAA;EAAJ;AACF;AAAM;EAVJ;IAWM,UAAA;EAGN;AACF;AADQ;EADF;IAEI,WAAA;IACA,kBAAA;EAIR;AACF;AAnBI;EAiBE;IACE,aAAA;EAKN;EAHM;IACE,aAAA;IACA,sBAAA;IACA,iBAAA;EAKR;EAFI;IACE,aAAA;IACA,sBAAA;IACA,gBAAA;IACA,SAAA;IACA,UAAA;EAIN;EAFM;IACE,YAAA;IACA,aAAA;EAIR;EAFQ;IACE,kBAAA;IACA,WAAA;EAIV;EAAM;IACE,gCAAA;IACA,eAAA;EAER;AACF;AAFU;EAHF;IAII,eAAA;EAKV;AACF;AAAE;EAtPF;IAuPI,mBAAA;IACA,gBAAA;EAGF;AACF;AAFE;EACE,qBAAA;AAIJ;AADE;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,yBAAA;EACA,gBAAA;EACA,+CAAA;EACA,UAAA;AAGJ;AAAE;EACE,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AAEJ;AACE;EAA2B,yBAAA;AAE7B;AAAE;EACE,cAAA;AAEJ;AAAE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;AAEJ;AACE;EACE,0BAAA;AACJ;AAEE;EACE,0BAAA;AAAJ;;AAGA;EACE,mBAAA;AAAF","sourcesContent":[".nav {\n  display: flex;\n  justify-content: space-between;\n  padding: 11px 30px 11px 0;\n  align-items: center;\n  background: transparent;\n  position: fixed;\n  top: 0;\n  z-index: 999;\n  transition: all .25s ease-in-out;\n  width: 100%;\n\n  a {\n    color: #EDEDED;\n    order: 3;\n  }\n\n  .logo_nav {\n\n      img {\n        vertical-align: middle;\n        width: 100%;\n      }\n\n\n    @media (max-width: 320px) {\n      width: 180px;\n    }\n    @media (max-width: 1200px) {\n     order: 1;\n    }\n  }\n\n  .nav_link {\n    display: flex;\n    @media (max-width: 1200px) {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      width: 100%;\n      position: fixed;\n      top: 70px;\n      height: auto;\n      bottom: 0;\n      left: -100%;\n      opacity: 1;\n      transition: all 0.5s ease;\n    }\n  }\n  .active1 {\n    @media (max-width: 1200px) {\n      background: #0A0A0A;\n      left: 0;\n      opacity: 1;\n      transition: all 0.5s ease;\n      z-index: 1;\n    }\n  }\n\n\n  .link {\n    font-family: 'hemi_head';\n    padding: 12px 26px;\n    position: relative;\n    font-size: 16px;\n    transition: 0.5s all;\n    color: #EDEDED;\n\n    &.active {\n      color: #ED1C24;\n    }\n    &:hover {\n      color: #ED1C24;\n    }\n\n    @media (max-width: 1280px) {\n      padding: 12px 20px;\n    }\n  }\n\n  .menu_icon {\n    display: none;\n\n    img {\n      width: 25px;\n    }\n\n    @media (max-width: 1200px) {\n      display: block;\n      order: 0;\n    }\n  }\n  #nav-icon1{\n    display: none;\n    width: 35px;\n    height:25px;\n    position: relative;\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .5s ease-in-out;\n    -moz-transition: .5s ease-in-out;\n    -o-transition: .5s ease-in-out;\n    transition: .5s ease-in-out;\n    cursor: pointer;\n    @media (max-width: 1200px) {\n      display: block;\n    }\n  }\n\n  #nav-icon1 span, #nav-icon3 span, #nav-icon4 span {\n    display: block;\n    position: absolute;\n    height: 3px;\n    width: 100%;\n    background: #FFFFFF;\n    border-radius: 9px;\n    opacity: 1;\n    left: 0;\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n    -webkit-transition: .25s ease-in-out;\n    -moz-transition: .25s ease-in-out;\n    -o-transition: .25s ease-in-out;\n    transition: .25s ease-in-out;\n  }\n\n  #nav-icon1 span:nth-child(1) {\n    top: 0px;\n  }\n\n  #nav-icon1 span:nth-child(2) {\n    top: 10px;\n  }\n\n  #nav-icon1 span:nth-child(3) {\n    top: 20px;\n  }\n\n  #nav-icon1.open span:nth-child(1) {\n    top: 18px;\n    -webkit-transform: rotate(135deg);\n    -moz-transform: rotate(135deg);\n    -o-transform: rotate(135deg);\n    transform: rotate(135deg);\n  }\n\n  #nav-icon1.open span:nth-child(2) {\n    opacity: 0;\n    left: -60px;\n  }\n\n  #nav-icon1.open span:nth-child(3) {\n    top: 18px;\n    -webkit-transform: rotate(-135deg);\n    -moz-transform: rotate(-135deg);\n    -o-transform: rotate(-135deg);\n    transform: rotate(-135deg);\n  }\n  @media (max-width: 1200px) {\n    padding: 11px 25px;\n  }\n  @media (max-width: 500px) {\n    padding: 15px;\n  }\n  .mob_links{\n    @media (max-width: 1200px) {\n      display: flex;\n      flex-direction: column;\n    }\n  }\n  .media{\n    display: none;\n    @media (max-width: 1200px) {\n      display: flex;\n      list-style: none;\n      margin: 10px 0;\n      justify-content: center;\n      padding: 0;\n      li{\n        padding: 0 7px;\n\n      }\n      img{\n        width: 25px;\n      }\n    }\n  }\n  .content {\n    display: none;\n    @media (max-width: 1200px) {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      width: 100%;\n      margin-left: 12px;\n      flex-wrap: wrap;\n      margin-bottom: 25px;\n      @media (max-width: 1386px) {\n        width: 95%;\n      }\n      div {\n        @media (max-width: 790px) {\n          width: 100%;\n          text-align: center;\n        }\n      }\n      .links {\n        display: flex;\n\n        ul {\n          display: flex;\n          flex-direction: column;\n          margin-left: 30px;\n        }\n      }\n      ul {\n        display: flex;\n        flex-direction: column;\n        list-style: none;\n        margin: 0;\n        padding: 0;\n\n        li {\n          padding: 4px;\n          display: flex;\n\n          svg {\n            margin-right: 10px;\n            width: 23px;\n          }\n        }\n\n        a {\n          color: rgba(255, 255, 255, 0.63);\n          font-size: 18px;\n          @media (max-width: 640px) {\n            font-size: 15px;\n          }\n        }\n      }\n    }\n  }\n  @media (max-width: 1200px) {\n    background: #0A0A0A;\n    position: sticky;\n  }\n  li.dropdown {\n    display: inline-block;\n  }\n\n  .dropdown-content {\n    display: none;\n    position: absolute;\n    top: 30px;\n    left: 0;\n    background-color: #0A0A0A;\n    min-width: 160px;\n    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n    z-index: 1;\n  }\n\n  .dropdown-content a {\n    color: #FFFFFF;\n    padding: 12px 16px;\n    text-decoration: none;\n    display: block;\n    text-align: left;\n  }\n\n  .dropdown-content a:hover {background-color: #0A1315;}\n\n  .dropdown:hover .dropdown-content {\n    display: block;\n  }\n  .dropbtn::after{\n    content: \"\\0025BC\";\n    transition: 0.2s;\n    position: absolute;\n  }\n\n  .dropbtn::after:hover{\n    transform: rotate(-180deg);\n  }\n\n  .dropdown:hover .dropbtn::after{\n    transform: rotate(-180deg);\n  }\n}\n.colorChange{\n  background: #0A0A0A;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
